import axios from 'axios';

const API_BASE = '/api/work-functions';

export const workFunctionService = {
  getAll: async () => {
    const response = await axios.get(API_BASE);
    return response.data;
  }
};
